<template>
  <el-form :model="formData" label-position="top">
    <el-form-item
      v-for="(platform, index) in platform_options"
      :key="index"
      :label="$t('HT.platform') + platform.name"
    >
      <el-radio-group v-model="formData.platform_ids[index]">
        <el-radio :label="0">{{ $t('HT.NO') }}</el-radio>
        <el-radio :label="1">{{ $t('HT.YES') }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="allowShowDataCenter" :label="$t('HT.Data.center')" prop="data_center_ids">
      <el-select
        v-model="formData.data_center_ids"
        multiple
        :placeholder="$t('HT.pleaseSelect')"
        @change="$forceUpdate()"
      >
        <el-option
          v-for="item in formData.data_center_options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    ids: {
      type: Number,
      default: () => ''
    }
  },
  data() {
    const vm = window.vm;
    return {
      vm: vm,
      formData: {
        platform_ids: [],
        data_center_ids: [],
        data_center_options: []
      },
      platform_options: []
    };
  },
  computed: {
    allowShowDataCenter() {
      let index = false;
      this.formData.platform_ids.forEach((item) => {
        if (item) {
          index = true;
        }
      });
      return index;
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$api.apply.getDataCenterOptions(this.ids).then((res) => {
        const { data_center_volist, platform_volist } = res.data;
        Object.assign(this.formData.data_center_options, data_center_volist);
        this.platform_options = platform_volist;
        this.formData.platform_ids = platform_volist.map((item) => item.bind ? 1 : 0);
        data_center_volist.forEach((item) => {
          item.bind && this.formData.data_center_ids.push(item.id);
        });
      });
    }
  }
};
</script>
